import PropTypes from 'prop-types';
import EligibilityItem from "./EligibilityItem";
import { jsx as _jsx } from "react/jsx-runtime";
const DISPLAY_NAME = 'program-detail-eligibility-type';

// Remove <br> before or after </strong> and collapse multiple <br> tags into one
const formatOtherFreeText = htmlString => htmlString?.replace(/<br\s*\/?>\s*(?=<\/strong>)/gi, '').replace(/<\/strong>\s*<br\s*\/?>/gi, '</strong> ').replace(/<\/div>\s*<br\s*\/?>/gi, '</div> ').replace(/<strong>\s*<br\s*\/?>\s*/gi, '<strong>').replace(/(<br\s*\/?>\s*){2,}/gi, '<br>').replace(/<(\w+)[^>]*>\s*<br\s*\/?>\s*<\/\1>/gi, '').replace(/^<(div|p)([^>]*)>([\s\S]*?)<\/\1>/i, '<span$2>$3</span>');
function EligibilityRequirements(_ref) {
  let {
    isProgramCard = false,
    populationRestrictions,
    cityRequirements,
    countyRequirements,
    stateRequirements,
    genderRequirements,
    ageRequirements,
    postalCodeRequirements,
    eligibilityText = ''
  } = _ref;
  const requirements = [{
    visibility: !!stateRequirements,
    title: 'States',
    options: stateRequirements
  }, {
    visibility: !!countyRequirements,
    title: 'Counties',
    options: countyRequirements
  }, {
    visibility: !!postalCodeRequirements,
    title: 'ZIP Codes',
    options: postalCodeRequirements
  }, {
    visibility: !!cityRequirements,
    title: 'Cities',
    options: cityRequirements
  }, {
    visibility: !!ageRequirements,
    title: 'Ages',
    options: ageRequirements
  }, {
    visibility: !!populationRestrictions,
    title: 'Populations',
    options: populationRestrictions
  }, {
    visibility: !!genderRequirements,
    title: 'Genders',
    options: genderRequirements
  }, {
    visibility: Boolean(eligibilityText) && isProgramCard,
    title: 'Other',
    /* eslint-disable-next-line react/no-danger */
    options: /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: {
        __html: formatOtherFreeText(eligibilityText)
      }
    })
  }];
  return /*#__PURE__*/_jsx("div", {
    className: "mx-4",
    children: /*#__PURE__*/_jsx("ul", {
      className: `${DISPLAY_NAME}-list list-disc pl-2`,
      children: requirements.map(_ref2 => {
        let {
          visibility,
          title,
          options
        } = _ref2;
        return /*#__PURE__*/_jsx(EligibilityItem, {
          visibility: visibility,
          title: title,
          options: options
        }, title);
      })
    })
  });
}
EligibilityRequirements.propTypes = {
  isProgramCard: PropTypes.bool,
  populationRestrictions: PropTypes.string.isRequired,
  cityRequirements: PropTypes.string.isRequired,
  countyRequirements: PropTypes.string.isRequired,
  stateRequirements: PropTypes.string.isRequired,
  genderRequirements: PropTypes.string.isRequired,
  ageRequirements: PropTypes.string.isRequired,
  postalCodeRequirements: PropTypes.string.isRequired,
  eligibilityText: PropTypes.string
};
export default EligibilityRequirements;
//# sourceMappingURL=EligibilityRequirements.js.map